import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields: []) => {
  const query = gql`
    query GetAllPart_MastersWithPopulate {
      GetAllPart_MastersWithPopulate {
        _id
        ${fields?.join(" ")}
      }
    }
    `;

  return query;
};

const ConsignorPart = () => {
  const [fetchMenuMaster, { loading, error, data }] = useLazyQuery(queryfunction([]), {
    fetchPolicy: "network-only",
  });
  const [loadingState, setLoading] = useState(true);
  const [formdata, setformdata] = useState([]);

  // Throw an error if the request is not fetched
  //Custom hook to fetch table data based on dynamic column selection.
  useFetchTableData(queryfunction, fetchMenuMaster);
  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  // Map the request data
  useEffect(() => {
    setLoading(true);
    let arr = data?.GetAllPart_MastersWithPopulate?.map((e) => {
      let obj = { ...e };
      delete obj.__typename;

      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      return obj;
    });
    setLoading(false);
    setformdata(arr);
  }, [data, loading]);

  return (
    <div>
      <HeaderDiv title="Consignor Part" PageType={"Master"} MoreActions={{ Is_Merge: true }} />
      {loadingState || loading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <LoadTable title="Consignor_Part" data={formdata} loading={loading} error={error} />
      )}
    </div>
  );
};

export default ConsignorPart;
